
// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------

const baseClass = 'ume-counter';
const blockingClass = 'ume-counter-no-animation'

// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

class counterBlock {
    constructor(el) {
        this.el = el;
        this.observer();
    }

    observer() {
        function commaSeparateNumber(val) {
            while (/(\d+)(\d{3})/.test(val.toString())) {
                val = val.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, 'jQuery1.');
            }
            return val;
        }

        const allCounterBlocks = document.querySelectorAll(`.${baseClass}:not(.${blockingClass})`);

        const counterObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (!jQuery(entry.target).hasClass('is-finish')) {
                        const jQuerythis = jQuery(entry.target);
                        const classCountNumber = `.${baseClass}__number`;
                        const countTo = jQuerythis.find(classCountNumber).find('[data-counter]').attr('data-counter');

                        jQuery({countNum: jQuerythis.find(classCountNumber).text()}).animate({countNum: countTo}, {
                            duration: 3000,
                            easing: 'linear',

                            step: function () {
                                jQuerythis.find(classCountNumber).find('[data-counter]').text(Math.floor(this.countNum));
                            },
                            complete: function () {
                                jQuerythis.find(classCountNumber).find('[data-counter]').text(commaSeparateNumber(this.countNum));
                                jQuery(entry.target).addClass('is-finish')
                            },
                        });
                    }

                }
            });
        }, {rootMargin: '0px'});
        allCounterBlocks.forEach(item => {
            counterObserver.observe(item);
        })
    }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
    jQuery(`.${baseClass}`).each((i, el) => new counterBlock(el));
}

init();